import OccupancyChartViewContainer from './OccupancyChartViewContainer';
export default OccupancyChartViewContainer;
